// @flow
import React from 'react'
import { CheckIcon } from 'src/assets/icons'
// styles
import { StyledBlock } from './thankYouBlockStyles'

// types
import type { ThankYouBlockTypes } from './ThankYouBlockTypes'

const ThankYouBlock = (props: ThankYouBlockTypes) => {
  return (
    <StyledBlock>
      <div className="block-body">
        <CheckIcon />
        <h2 className="title">Thank you!</h2>
        <h4 className="subtitle">{props.message}</h4>
      </div>
    </StyledBlock>
  )
}

export default ThankYouBlock
